import { useEffect } from 'react';

type KeyHandler = (event: KeyboardEvent) => void;

export function useKeyboardShortcut(key: string | undefined, callback: KeyHandler, ctrl = false) {
  useEffect(() => {
    if (!key) return; // Early return if no key provided

    const handler = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() === key.toLowerCase() && (!ctrl || event.ctrlKey)) {
        callback(event);
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [key, callback, ctrl]);
}